import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Icons from "../../assets/icons/index";
import Images from "../../assets/images/index";
import { extensionCheck, getExtensionList, getSubscriptionList, logoutDevice } from "../../restApi/api";
import { decrypt, decryptdata } from "../../utils/crypto";
import Authorization, { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { Package_detail_Api } from "../../gql/queries";
import { useQuery } from "@apollo/client";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import { toast, ToastContainer } from 'react-toastify';
import ConnectionError from "../common/NoDataFound/ConnectionError";

export default function MyActivePlans() {
    // const [active, setActive] = useState([]);
    // const [isActive, setIsActive] = useState([]);
    // const [extend, setExtendData] = useState([]);
    let navigate = useNavigate()
    const location = useLocation();
    let [isEligible, setEligible] = useState(false);
    let [extensionData, setExtensionData] = useState(true)
    // let [packageId, setPackageId] = useState('');
    let [loader, setloader] = useState(true)
    const showToast = (message) => {
        toast.success(message);
    };

    const showToastError = (message) => {
        toast.error(message);
    };
    // const activePlanList = async () => {
    //     await getSubscriptionList()
    //         .then(response => {
    //             return response.json()
    //         })
    //         .then(data => {
    //             let req = JSON.parse(decrypt(data))
    //             if (req.data.code === 1) {
    //                 let activePlans = [];
    //                 req.data.result.package.map((i) => {
    //                     i.packages.map(dat => {
    //                         if (dat.purchased === true) {
    //                             activePlans.push(dat)
    //                         }
    //                     })
    //                     setIsActive(activePlans);
    //                 })
    //             }
    //             else if (req.data.code == 402) {
    //                 authorizationCheck(navigate)
    //             }
    //         })
    // }
    // const extendedList = async () => {
    //     let da = {}
    //     await getExtensionList(da)
    //         .then(response => {
    //             return response.json()
    //         })
    //         .then(data => {
    //             setloader(false)
    //             let req = JSON.parse(decrypt(data))
    //             if (req.data.code == 1) {
    //                 setExtendData(req.data.result.packages)
    //             }
    //         }).catch((error) => {
    //             setloader(false)
    //         })
    // }
    const navigated = () => {
        navigate('/package')
    }

    useEffect(() => {
        setloader(true)
        // activePlanList()
        // extendedList()
    }, []);
    const query1 = useQuery(Package_detail_Api, {
        variables: {
            "packageType": 'SUBSCRIPTION'
        },
        fetchPolicy: 'network-only'
    });
    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        } 
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error)
    }
    let activePlans = [];
    query1.data?.listPackagesForApp?.map((obj) => {
        if (obj?.packagePurchased?.transactionStatus === 'COMPLETED' && obj?.packagePurchased?.expire==false) {
            activePlans.push(obj)
        }
    })
    const navigateToPlanAddons = (obj) => {
        extensionData = obj
        setExtensionData(obj)
        const data = {
            "packageId": obj?._id
        }
        extensionCheck(data)
            .then(response => {
                return response.json()
            })
            .then((data) => {
                if (data?.success == true) {
                    if (data?.data?.orderEligibleForExtension !== null) {
                        isEligible = true
                        setEligible(true)
                    }
                    else {
                        isEligible = false
                        setEligible(false)
                    }
                }
                else {
                    showToastError(data?.message)
                }
            }).catch((error) => {
                showToastError("Something went wrong please try agian")
            })
    };
    if (isEligible == true) {
        navigate('/package/extension', { state: JSON.stringify(extensionData) });
    }
    return (
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    <li className="breadcrumb-item"><a >Home</a></li>
                    <li className="breadcrumb-item active"><a >Subscription</a></li>
                </ul>
            </div>
            <section className="videoLayer_wrapper subscriptions_wrapper activePlans_wrapper section_side_padding">
            <ToastContainer />
                <div className='row'>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="recommended_video_wrapper">
                            <div className="subscription_ttl">
                                <h5>My Plans</h5>
                            </div>
                        </div>
                        <div className="recommended_video_wrapper">
                            <div className="tabs_wrapper">
                                <div className="subcription_inner_tabs">
                                    <div className="active_plans_ttl">
                                        <h5>{activePlans.length} Active Plans</h5>
                                    </div>
                                    <div className="subscription_main_content">
                                        <div className="row">
                                            {
                                                activePlans && activePlans.sort((a, b) => (a.position > b.position ? 1 : -1)).map(d => (
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="plans_wrapper" style={{ borderColor: `${d.colorCode}` }}>
                                                            <div className="plans_header d-flex align-items-center" style={{ background: `${d.colorCode}` }}>
                                                                <div className="plans_name">
                                                                    {/* {
                                                                        d?.packagePurchased?.transactionStatus === 'COMPLETED' &&
                                                                        <div className="plan_tag d-flex">
                                                                            <h6>{d.title}</h6>
                                                                            <span>Purchased</span>
                                                                        </div>
                                                                    } */}
                                                                    {
                                                                        (d?.packagePurchased?.transactionStatus === 'COMPLETED' || d?.packagePurchased?.isAssignedPackageByAdmin === true) &&
                                                                        <div className="plan_tag d-flex">
                                                                            <h6>{d.title}</h6>
                                                                            <span>Purchased</span>
                                                                        </div>
                                                                    }
                                                                    <p>{d.subtitle}</p>
                                                                </div>
                                                                <div className="plan_price">
                                                                    <h6><span>Starts From</span> ₹{d.validity[0]?.discountPrice !== 0 ? d.validity[0]?.discountPrice : d.validity[0]?.mrp}</h6>
                                                                    {
                                                                        d.validity[0]?.discountPrice !== 0 &&
                                                                        <del><h6>₹{d.validity[0]?.mrp}</h6></del>
                                                                    }
                                                                    <p>{d.validity[0]?.validityTitle}</p>
                                                                </div>
                                                            </div>
                                                            <div className="plans_body">
                                                                <ul type="none">
                                                                    {
                                                                        d && d?.newDescription && d?.newDescription?.map(listdata => (
                                                                            <li>{listdata}</li>
                                                                        ))
                                                                    }
                                                                    {/* <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                    <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                    <li>To the point explanation.</li>
                                                                    <li>Make your own Qbank with Custom Qbank module</li> */}
                                                                </ul>
                                                            </div>
                                                            <div className="plans_footer text-right">
                                                                {
                                                                    (d?.packagePurchased?.boughtWithNotes != true || d?.packagePurchased?.boughtWithVibe != true)  && d?.packagePurchased?.hasExpired === false &&
                                                                    d.validity.map(obj => (
                                                                        obj._id.toString() == d?.packagePurchased?.validityId && (((obj.withNotes || obj.withPenDrive) && (d?.packagePurchased?.boughtWithNotes != obj.withNotes || d?.packagePurchased?.boughtWithVibe != obj.withPenDrive)) && d?.packagePurchased?.isAssignedPackageByAdmin != true) && d?.packagePurchased?.transactionStatus === 'COMPLETED' &&
                                                                        <Link to={`/package/Addons/${d._id}`}>
                                                                            <a href="javascript:;">
                                                                                <button type="button" className="btn btsubscriptionn_addons btn_addons" style={{ background: `${d?.colorCode}` }}>Buy Add Ons</button>
                                                                            </a>
                                                                        </Link>
                                                                    ))
                                                                }
                                                                {
                                                                    (d?.packagePurchased !== null && d?.packageExtension != null  || d?.packagePurchased?.hasExpired == true) && d?.isAvailableExtension==true &&
                                                                    // <Link to={`/package/extension`} state={JSON.stringify(d._id)}>
                                                                    <a href="javascript:;">
                                                                        <button type="button" className="btn btn_addons" style={{ background: `${d?.colorCode ? d?.colorCode:"rgb(237, 248, 241)"}` }} onClick={() => navigateToPlanAddons(d)} >Extend Plan</button>
                                                                    </a>
                                                                    // </Link>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            {activePlans.length === 0 && <NoDataFound />}
                                            {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="plans_wrapper">
                                                    <div className="plans_header d-flex align-items-center">
                                                        <div className="plans_name">
                                                            <h6>Advance Plus</h6>
                                                            <p>Advance Pack & Clinical World</p>
                                                        </div>
                                                        <div className="plan_price">
                                                            <h6>₹22,499</h6>
                                                            <p>Valid Till 30th OCT 2022</p>
                                                        </div>
                                                    </div>
                                                    <div className="plans_body">
                                                        <ul type="none">
                                                            <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                            <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                            <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                            <li>To the point explanation.</li>
                                                            <li>Make your own Qbank with Custom Qbank module</li>
                                                        </ul>
                                                    </div>
                                                    <div className="plans_footer text-center">
                                                        <button type="button" className="btn btn_addons">Buy Add Ons</button>
                                                        <button type="button" className="btn btn_addons">Extend Plan</button>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="manage_subscriptions" onClick={navigated}>
                                    <a href="javascript:;">Buy New plans/ Add-ons/ Vibes<img src={Icons.ArrowBlue} alt="" className="img-fluid" /></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-lg-4 col-md-4 col-sm-12"> */}
                    {/* <div className="videos_wrapper">
                            <div className="buy_packages d-flex align-items-center">
                                <div className="package_text">
                                    <h6>Buy Package</h6>
                                    <p>Buy Package to unlock content and Start Learning</p>
                                </div>
                                <div className="package_img">
                                    <img src={Images.Package} alt="" className="img-fluid"/>
                                </div>
                            </div>
                        </div> */}
                    {/* </div> */}
                </div>
            </section>
        </div>
    )
}